import "reflect-metadata";
import '$src/infrastructure/DependencyInection'
import '$src/application/DependencyInjection'
import './app.css'
import App from './App.svelte'


const app = new App({
  target: document.getElementById('app')!,
})

export default app
